import React from 'react';
import { Animated } from 'react-native';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { useMilestoneNodes, useProgressAnimate } from './hooks';
import { useProgressStyle } from './style';
export function Progress(props) {
    const { pivotNode, pivotText, percentage, milestone = [] } = props || {};
    const { style } = useProgressStyle(props);
    const { milestoneNodes } = useMilestoneNodes(props);
    const { trackActiveAnimateVal, trackInActiveAnimateVal } = useProgressAnimate(percentage, !!(milestone === null || milestone === void 0 ? void 0 : milestone.length));
    return (React.createElement(Flex, { flex: 'flexRowCenter', style: { position: 'relative' } },
        milestoneNodes.map((v) => v.node),
        React.createElement(Animated.View, { style: [style.activeBar, { flex: trackActiveAnimateVal }] }),
        pivotNode === undefined ? (React.createElement(Box, { style: style.pivotNode }, pivotText !== null && pivotText !== void 0 ? pivotText : `${percentage}%`)) : (pivotNode),
        React.createElement(Animated.View, { style: [style.inactiveBar, { flex: trackInActiveAnimateVal }] })));
}
export default Progress;
